import { Injectable } from '@angular/core';
import { ParamMap } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { isNil, cloneDeep } from 'lodash-es';
import { ToastrService } from 'ngx-toastr';

import { WavelengthShellService } from 'wavelength-ui';
import { EModalSize, EToasterType, EToasterPosition } from 'wavelength-ui';


import { CleanupLoggerService } from './cleanup.logging.service';
import { ProgrammableLogicController_configuration_formComponent } from './ProgrammableLogicController.configuration_form.component';
import { ProgrammableLogicController_plc_homeComponent } from './ProgrammableLogicController.plc_home.component';
import { ProgrammableLogicController_connector_mappings_gridComponent } from './ProgrammableLogicController.connector_mappings_grid.component';
import { ProgrammableLogicController_connectors_gridComponent } from './ProgrammableLogicController.connectors_grid.component';
import { ProgrammableLogicController_totegroupings_gridComponent } from './ProgrammableLogicController.totegroupings_grid.component';
import { ProgrammableLogicController_PLC_HubComponent } from './ProgrammableLogicController.PLC_Hub.component';
import { ProgrammableLogicController_connector_settings_singleComponent } from './ProgrammableLogicController.connector_settings_single.component';
import { ProgrammableLogicController_connectors_dd_singleComponent } from './ProgrammableLogicController.connectors_dd_single.component';
import { ProgrammableLogicController_location_zone_dd_singleComponent } from './ProgrammableLogicController.location_zone_dd_single.component';
import { ProgrammableLogicController_orderclasses_dd_singleComponent } from './ProgrammableLogicController.orderclasses_dd_single.component';
import { ProgrammableLogicController_plc_type_dd_singleComponent } from './ProgrammableLogicController.plc_type_dd_single.component';
import { ProgrammableLogicController_projects_dd_singleComponent } from './ProgrammableLogicController.projects_dd_single.component';
import { ProgrammableLogicController_warehouses_dd_singleComponent } from './ProgrammableLogicController.warehouses_dd_single.component';
import { ProgrammableLogicController_connector_settings_multiComponent } from './ProgrammableLogicController.connector_settings_multi.component';
import { ProgrammableLogicController_connectors_dd_multiComponent } from './ProgrammableLogicController.connectors_dd_multi.component';
import { ProgrammableLogicController_location_zone_dd_multiComponent } from './ProgrammableLogicController.location_zone_dd_multi.component';
import { ProgrammableLogicController_orderclasses_dd_multiComponent } from './ProgrammableLogicController.orderclasses_dd_multi.component';
import { ProgrammableLogicController_plc_type_dd_multiComponent } from './ProgrammableLogicController.plc_type_dd_multi.component';
import { ProgrammableLogicController_projects_dd_multiComponent } from './ProgrammableLogicController.projects_dd_multi.component';
import { ProgrammableLogicController_warehouses_dd_multiComponent } from './ProgrammableLogicController.warehouses_dd_multi.component';

import { Utilities_ShellService } from './Utilities.shell.service';
import { Totes_ShellService } from './Totes.shell.service';

@Injectable({ providedIn: 'root' })
export class ProgrammableLogicController_ShellService extends WavelengthShellService  {
  constructor(
    dialog : MatDialog,
    toastr: ToastrService,
    private $logger: CleanupLoggerService,
    public Utilities: Utilities_ShellService,
    public Totes: Totes_ShellService,
  ) {
    super(dialog, toastr);
  }

  public ProgrammableLogicController: ProgrammableLogicController_ShellService = this;

  public openconfiguration_form(replaceCurrentView?: boolean) {
    this.$logger.log('ProgrammableLogicController', 'configuration_form');
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'New configuration',
        referenceName: 'ProgrammableLogicController_configuration_form',
        component: ProgrammableLogicController_configuration_formComponent,
        replaceCurrentView: replaceCurrentView,
        
      }
    );
  }

  public openconfiguration_formDialog(
    
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<{ warehouse?: number, project?: number, connector_name?: string, connector_type?: string, order_class?: number }> {
    this.$logger.log('ProgrammableLogicController', 'configuration_form');
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      ProgrammableLogicController_configuration_formComponent,
      'New configuration',
      mode,
      dialogSize
    )
  }
  public openplc_home(replaceCurrentView?: boolean) {
    this.$logger.log('ProgrammableLogicController', 'plc_home');
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'PLC home page',
        referenceName: 'ProgrammableLogicController_plc_home',
        component: ProgrammableLogicController_plc_homeComponent,
        replaceCurrentView: replaceCurrentView,
        
      }
    );
  }

  public openplc_homeDialog(
    
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    this.$logger.log('ProgrammableLogicController', 'plc_home');
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      ProgrammableLogicController_plc_homeComponent,
      'PLC home page',
      mode,
      dialogSize
    )
  }
  public openconnector_mappings_grid(replaceCurrentView?: boolean) {
    this.$logger.log('ProgrammableLogicController', 'connector_mappings_grid');
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Connector mapping',
        referenceName: 'ProgrammableLogicController_connector_mappings_grid',
        component: ProgrammableLogicController_connector_mappings_gridComponent,
        replaceCurrentView: replaceCurrentView,
        
      }
    );
  }

  public openconnector_mappings_gridDialog(
    
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    this.$logger.log('ProgrammableLogicController', 'connector_mappings_grid');
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      ProgrammableLogicController_connector_mappings_gridComponent,
      'Connector mapping',
      mode,
      dialogSize
    )
  }
  public openconnectors_grid(replaceCurrentView?: boolean) {
    this.$logger.log('ProgrammableLogicController', 'connectors_grid');
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Connectors',
        referenceName: 'ProgrammableLogicController_connectors_grid',
        component: ProgrammableLogicController_connectors_gridComponent,
        replaceCurrentView: replaceCurrentView,
        
      }
    );
  }

  public openconnectors_gridDialog(
    
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    this.$logger.log('ProgrammableLogicController', 'connectors_grid');
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      ProgrammableLogicController_connectors_gridComponent,
      'Connectors',
      mode,
      dialogSize
    )
  }
  public opentotegroupings_grid(replaceCurrentView?: boolean) {
    this.$logger.log('ProgrammableLogicController', 'totegroupings_grid');
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Tote groupings',
        referenceName: 'ProgrammableLogicController_totegroupings_grid',
        component: ProgrammableLogicController_totegroupings_gridComponent,
        replaceCurrentView: replaceCurrentView,
        
      }
    );
  }

  public opentotegroupings_gridDialog(
    
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    this.$logger.log('ProgrammableLogicController', 'totegroupings_grid');
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      ProgrammableLogicController_totegroupings_gridComponent,
      'Tote groupings',
      mode,
      dialogSize
    )
  }
  public openPLC_Hub(replaceCurrentView?: boolean) {
    this.$logger.log('ProgrammableLogicController', 'PLC_Hub');
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Programmable logic controller hub',
        referenceName: 'ProgrammableLogicController_PLC_Hub',
        component: ProgrammableLogicController_PLC_HubComponent,
        replaceCurrentView: replaceCurrentView,
        
      }
    );
  }

  public openPLC_HubDialog(
    
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    this.$logger.log('ProgrammableLogicController', 'PLC_Hub');
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      ProgrammableLogicController_PLC_HubComponent,
      'Programmable logic controller hub',
      mode,
      dialogSize
    )
  }

  public override getComponentInformation(referenceName: string, params: ParamMap): { title: string, component: any, inParams: any } {
    if (referenceName === 'ProgrammableLogicController_configuration_form') {
      this.$logger.log('ProgrammableLogicController', 'configuration_form');
      const title = 'New configuration';
      const component = ProgrammableLogicController_configuration_formComponent;
      const inParams = null;

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'ProgrammableLogicController_plc_home') {
      this.$logger.log('ProgrammableLogicController', 'plc_home');
      const title = 'PLC home page';
      const component = ProgrammableLogicController_plc_homeComponent;
      const inParams = null;

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'ProgrammableLogicController_connector_mappings_grid') {
      this.$logger.log('ProgrammableLogicController', 'connector_mappings_grid');
      const title = 'Connector mapping';
      const component = ProgrammableLogicController_connector_mappings_gridComponent;
      const inParams = null;

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'ProgrammableLogicController_connectors_grid') {
      this.$logger.log('ProgrammableLogicController', 'connectors_grid');
      const title = 'Connectors';
      const component = ProgrammableLogicController_connectors_gridComponent;
      const inParams = null;

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'ProgrammableLogicController_totegroupings_grid') {
      this.$logger.log('ProgrammableLogicController', 'totegroupings_grid');
      const title = 'Tote groupings';
      const component = ProgrammableLogicController_totegroupings_gridComponent;
      const inParams = null;

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'ProgrammableLogicController_PLC_Hub') {
      this.$logger.log('ProgrammableLogicController', 'PLC_Hub');
      const title = 'Programmable logic controller hub';
      const component = ProgrammableLogicController_PLC_HubComponent;
      const inParams = null;

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'ProgrammableLogicController_connector_settings_single') {
      this.$logger.log('ProgrammableLogicController', 'connector_settings_single');
      const title = 'connector_settings';
      const component = ProgrammableLogicController_connector_settings_singleComponent;
      const inParams = null;

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'ProgrammableLogicController_connectors_dd_single') {
      this.$logger.log('ProgrammableLogicController', 'connectors_dd_single');
      const title = 'connectors_dd';
      const component = ProgrammableLogicController_connectors_dd_singleComponent;
      const inParams = null;

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'ProgrammableLogicController_location_zone_dd_single') {
      this.$logger.log('ProgrammableLogicController', 'location_zone_dd_single');
      const title = 'location_zone_dd';
      const component = ProgrammableLogicController_location_zone_dd_singleComponent;
      const inParams:{ warehouseId?: number } = { warehouseId: null };
      if (!isNil(params.get('warehouseId'))) {
        const paramValueString = params.get('warehouseId');
        inParams.warehouseId = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'ProgrammableLogicController_orderclasses_dd_single') {
      this.$logger.log('ProgrammableLogicController', 'orderclasses_dd_single');
      const title = 'orderclasses_dd';
      const component = ProgrammableLogicController_orderclasses_dd_singleComponent;
      const inParams = null;

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'ProgrammableLogicController_plc_type_dd_single') {
      this.$logger.log('ProgrammableLogicController', 'plc_type_dd_single');
      const title = 'plc_type_dd';
      const component = ProgrammableLogicController_plc_type_dd_singleComponent;
      const inParams = null;

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'ProgrammableLogicController_projects_dd_single') {
      this.$logger.log('ProgrammableLogicController', 'projects_dd_single');
      const title = 'projects_dd';
      const component = ProgrammableLogicController_projects_dd_singleComponent;
      const inParams = null;

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'ProgrammableLogicController_warehouses_dd_single') {
      this.$logger.log('ProgrammableLogicController', 'warehouses_dd_single');
      const title = 'Warehouses Dropdown';
      const component = ProgrammableLogicController_warehouses_dd_singleComponent;
      const inParams:{ warehouseId?: number } = { warehouseId: null };
      if (!isNil(params.get('warehouseId'))) {
        const paramValueString = params.get('warehouseId');
        inParams.warehouseId = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'ProgrammableLogicController_connector_settings_multi') {
      this.$logger.log('ProgrammableLogicController', 'connector_settings_multi');
      const title = 'connector_settings';
      const component = ProgrammableLogicController_connector_settings_multiComponent;
      const inParams = null;

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'ProgrammableLogicController_connectors_dd_multi') {
      this.$logger.log('ProgrammableLogicController', 'connectors_dd_multi');
      const title = 'connectors_dd';
      const component = ProgrammableLogicController_connectors_dd_multiComponent;
      const inParams = null;

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'ProgrammableLogicController_location_zone_dd_multi') {
      this.$logger.log('ProgrammableLogicController', 'location_zone_dd_multi');
      const title = 'location_zone_dd';
      const component = ProgrammableLogicController_location_zone_dd_multiComponent;
      const inParams:{ warehouseId?: number } = { warehouseId: null };
      if (!isNil(params.get('warehouseId'))) {
        const paramValueString = params.get('warehouseId');
        inParams.warehouseId = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'ProgrammableLogicController_orderclasses_dd_multi') {
      this.$logger.log('ProgrammableLogicController', 'orderclasses_dd_multi');
      const title = 'orderclasses_dd';
      const component = ProgrammableLogicController_orderclasses_dd_multiComponent;
      const inParams = null;

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'ProgrammableLogicController_plc_type_dd_multi') {
      this.$logger.log('ProgrammableLogicController', 'plc_type_dd_multi');
      const title = 'plc_type_dd';
      const component = ProgrammableLogicController_plc_type_dd_multiComponent;
      const inParams = null;

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'ProgrammableLogicController_projects_dd_multi') {
      this.$logger.log('ProgrammableLogicController', 'projects_dd_multi');
      const title = 'projects_dd';
      const component = ProgrammableLogicController_projects_dd_multiComponent;
      const inParams = null;

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'ProgrammableLogicController_warehouses_dd_multi') {
      this.$logger.log('ProgrammableLogicController', 'warehouses_dd_multi');
      const title = 'Warehouses Dropdown';
      const component = ProgrammableLogicController_warehouses_dd_multiComponent;
      const inParams:{ warehouseId?: number } = { warehouseId: null };
      if (!isNil(params.get('warehouseId'))) {
        const paramValueString = params.get('warehouseId');
        inParams.warehouseId = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }


    let result = null;
    result = this.Utilities.getComponentInformation(referenceName, params);
    if (result) {
      return result;
    }
    result = this.Totes.getComponentInformation(referenceName, params);
    if (result) {
      return result;
    }
    return result;
  }
}
